import { render, staticRenderFns } from "./MusicGen.vue?vue&type=template&id=5503c8ae&scoped=true&"
import script from "./MusicGen.vue?vue&type=script&lang=js&"
export * from "./MusicGen.vue?vue&type=script&lang=js&"
import style0 from "./MusicGen.vue?vue&type=style&index=0&id=5503c8ae&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5503c8ae",
  null
  
)

export default component.exports